import { Injectable } from '@angular/core';
import { FieldType } from '@shared/components/dynamic-form/models/field';
import {
  CHOICES_RATING_DEFINITION,
  FIELD_TYPE,
  FREE_TEXT_DEFINITION,
  SECTION_SUMMARY_DEFINITION,
  STAR_RATING_DEFINITION,
  TEXT_FIELD_DEFINITION,
  YES_NO_RATING_DEFINITION,
} from '@shared/constants/field-type.const';

@Injectable({
  providedIn: 'root',
})
export class FieldTypeService {
  private readonly fieldTypes = new Map<string, FieldType>([
    [FIELD_TYPE.STAR_RATING, STAR_RATING_DEFINITION],
    [FIELD_TYPE.CHOICES_RATING, CHOICES_RATING_DEFINITION],
    [FIELD_TYPE.YES_NO_RATING, YES_NO_RATING_DEFINITION],
    [FIELD_TYPE.TEXTBOX, TEXT_FIELD_DEFINITION],
    [FIELD_TYPE.SECTION_SUMMARY, SECTION_SUMMARY_DEFINITION],
    [FIELD_TYPE.FREE_TEXT, FREE_TEXT_DEFINITION],
  ]);

  getFieldType(type: string): FieldType | undefined {
    return this.fieldTypes.get(type);
  }

  getFieldTypes(): FieldType[] {
    return Array.from(this.fieldTypes.values());
  }

  getFieldTypesByCategory(): { categoryName: string; types: FieldType[] }[] {
    return [
      {
        categoryName: 'JuryForm.Section.RatingElements',
        types: [
          STAR_RATING_DEFINITION,
          CHOICES_RATING_DEFINITION,
          YES_NO_RATING_DEFINITION,
          TEXT_FIELD_DEFINITION,
          SECTION_SUMMARY_DEFINITION,
        ],
      },
      {
        categoryName: 'JuryForm.Section.TextElements',
        types: [FREE_TEXT_DEFINITION],
      },
    ];
  }
}
